import Vue from 'vue'
import Vuex from 'vuex'
import MetricsService from '../../services/MetricsService'
import VueMoment from 'vue-moment'

Vue.use(Vuex)
Vue.use(VueMoment)
export default {
  namespaced: true,
  state: {
    filters: {
      churnType: null,
      startMonth: '2015-01-01',
      endMonth: Vue.moment().startOf('month').format('YYYY-MM-DD')
    },
    data: {
      churned_trainers: []
    }
  },
  mutations: {
    setFilterStartMonth (state, month) {
      state.filters.month = month
    },
    setFilterEndMonth (state, month) {
      state.filters.month = month
    },
    setFilterChurnType (state, churnType) {
      state.filters.churnType = churnType
    },
    setData (state, data) {
      state.data = data
    }
  },
  actions: {
    loadData ({commit, state}) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true, { root: true })
        let metricsService = new MetricsService()
        metricsService
          .getChurnedTrainers({
            'start_month': state.filters.startMonth,
            'end_month': state.filters.endMonth,
            'churn_type': state.filters.churnType
          })
          .then((res) => {
            commit('setData', res.data)
            resolve()
          })
          .catch((e) => {
            reject(e)
          })
          .finally(() => {
            commit('setLoading', false, { root: true })
          })
      })
    }
  },
  getters: {
    getFilterStartMonth (state) {
      return state.filters.startMonth
    },
    getFilterEndMonth (state) {
      return state.filters.endMonth
    },
    getFilterChurnType (state) {
      return state.filters.churnType
    },
    getChurnedTrainers (state) {
      return state.data.churned_trainers
    }
  }
}
